module.exports = __webpack_public_path__ + "img/aboutus_banner.2b48f5b8.png";